export default {
  SET_SHIFTS(state, shifts) {
    state.shifts = shifts;
  }
};